var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-notifications'),(_vm.isAuth)?_c('header-comp'):_vm._e(),(_vm.isAuth)?_c('side-bar'):_vm._e(),_c('v-main',{staticClass:"whitegrey"},[_c('router-view',{class:_vm.isAuth? '' : _vm.$route.name == 'OrdersTvPanel'? '' : 'red darken-3'})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }